import React from "react"

import { Icon } from "@/components"

import classes from "@/components/SelectableBadge/SelectableBadge.module.css"

interface Props {
    active: boolean
    text: string
    onClick: () => void | Promise<void>
}

export const SelectableBadge = ({ active, text, onClick }: Props) => (
    <button className={active ? classes.activeBadge : classes.inactiveBadge} type="button" onClick={onClick}>
        {active && <Icon className={classes.iconCheck} icon="check" size="sm" />}
        {text}
    </button>
)
